import TransactionsTable from "../TransactionsTable";

const OutwardTransactions = () => {
  return (
    <div className="w-full mt-3">
      <TransactionsTable />
    </div>
  );
};

export default OutwardTransactions;
